import Swiper from 'swiper'

window.addEventListener('DOMContentLoaded', function () {
  const $instances = Array.from(document.querySelectorAll('.aps-resources'))

  $instances.forEach($rootEl => {
    const $content = $rootEl.querySelector('.aps-resources__content')
    const swiper = new Swiper($content, {
      slideClass: 'aps-resources__tab-content',
      createElements: true,
      effect: 'fade',
      speed: 400,
      fadeEffect: {
        crossFade: true,
      },
    })

    const $tabs = Array.from($rootEl.querySelectorAll('.aps-resources__tab'))

    if ($tabs.length) {
      $tabs[0].classList.add('aps-resources__tab--active')

      swiper.on('slideChange', function () {
        $tabs.forEach(function ($tab, i) {
          if (i === swiper.activeIndex) {
            $tab.classList.add('aps-resources__tab--active')
          } else {
            $tab.classList.remove('aps-resources__tab--active')
          }
        })
      })

      $tabs.forEach(function ($tab, i) {
        $tab.addEventListener('click', function (ev) {
          ev.preventDefault()
          swiper.slideTo(i)
        })
      })
    }

    const $expandBtns = Array.from($rootEl.querySelectorAll('.aps-resources__expand'))

    if ($expandBtns.length) {
      $expandBtns.forEach(function ($btn) {
        $btn.addEventListener('click', function (ev) {
          ev.preventDefault()
          this.parentNode.parentNode.classList.toggle('aps-resources__list--expanded')
        })
      })
    }
  })
})
